var modalConfirm = function (callback) {
        $("#modal-btn-confirm-yes").unbind("click").on("click", function () {
            callback(true);
            $("#simple-confirm-modal").modal('hide');
        });
        $("#modal-btn-confirm-no").unbind("click").on("click", function () {
            callback(false);
            $("#simple-confirm-modal").modal('hide');
        });
    }, varG1, varG2, varG3, varG4,
    isAdvancedUpload, totalFilesCount, curentFileIndex;

var phoneCodes, app = {
    authForms: function () {
        /** Jquery csrf-token */
        $.ajaxSetup({
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
        });

        /** Register */
        var $applytypeRadio = $('input[name="applytype"]');
        if ($applytypeRadio.length) {
            $applytypeRadio.change(function () {
                if ($('input[name="applytype"]:checked').val() === 'host') {
                    $('.form-group-company').removeClass('d-none');
                } else {
                    $('.form-group-company').addClass('d-none');
                }
            }).trigger('change');
        }

        /** Previous Us Visits */
        if ($('.previous-us-visits').length === 1) {
            $('[type="radio"]', $('form.previous-us-visits')).click(function () {
                var name = $(this).attr('name');
                if ($(this).is(':checked')) {
                    if ($(this).val() === '0') {
                        $('.' + name + '_exp').addClass('d-none');
                    } else {
                        $('.' + name + '_exp').removeClass('d-none').find('input').first().focus();
                    }
                } else {
                    $('.' + name + '_exp').addClass('d-none');
                }
            });
        }

        /** Interview */
        if ($('.appointment-page').length === 1) {
            var $appointmentCont = $('.appointment-cont');
            if ($appointmentCont.length === 1) {
                /** Bootstrap Datepicker */
                var $dp = $('.appointment-date'),
                    $tz = $('#timezone'),
                    $hourSelectZone = $('.hour-select-zone'),
                    $selectedInterviewer = $('.selected-interviewer'),
                    $hoursZone = $('.hours', '.hour-select-zone'),
                    $pickedTime = $('.picked-time'),
                    $interviewSubmit = $('.interview-submit');

                function pad(str) {
                    var max = 2;
                    str = str.toString();
                    return str.length < max ? pad("0" + str, max) : str;
                }

                function formatAMPM(hours) {
                    var ampm = hours >= 12 ? 'PM' : 'AM';
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    return pad(hours) + ':00 ' + ampm;
                }

                function hasClass(elem, className) {
                    return elem.className.split(' ').indexOf(className) > -1;
                }

                var timeZoneChanged = function () {
                    var selectedTimeZone = $tz.val();
                    $hourSelectZone.hide();
                    $selectedInterviewer.hide();
                    $pickedTime.html('');
                    $hoursZone.empty();
                    $interviewSubmit.attr('disabled', 'disabled');
                    if (selectedTimeZone) {
                        moment.tz.setDefault(selectedTimeZone);

                        /** Disabled Dates */
                        var setDates = [],
                            disabledDates = [];
                        $.each(utcDateTimes, function (index, value) {

                            //console.log(moment.utc(value.utc).format(),'->',moment.utc(value.utc).tz(selectedTimeZone).format());
                            var rowDate = moment.utc(value.utc).tz(selectedTimeZone);
                            setDates.push(rowDate.format('DD/MM/YYYY'));
                        });
                        var a = moment($dp.datepicker('getStartDate')).subtract(1, 'day');
                        var b = moment($dp.datepicker('getEndDate')).add(2, 'day'); // 3 gün güvenlik için eklendi. Değişmesin
                        for (var m = moment(a); m.isBefore(b); m.add(1, 'days')) {
                            if (setDates.indexOf(m.format('DD/MM/YYYY')) === -1) {
                                //console.log(m.format('DD/MM/YYYY'));
                                disabledDates.push(m.format('DD/MM/YYYY'))
                            }
                        }
                        //console.log(setDates);
                        $dp.datepicker('setDatesDisabled', disabledDates);

                        /** On TimeZone Change */
                        $tz.on('change', timeZoneChanged);
                        $dp.off('changeDate').on('changeDate', datePicked);
                    }
                }
                var datePicked = function () {
                    $hourSelectZone.hide();
                    $selectedInterviewer.hide();
                    $hoursZone.empty();
                    $pickedTime.html('');
                    $interviewSubmit.attr('disabled', 'disabled');
                    // Eğer time zone seçili ise
                    var selectedTimeZone = $tz.val();
                    if (selectedTimeZone) {
                        // Tarih Seçilmiş ise
                        var pickedDate = $dp.datepicker('getUTCDate');
                        if (pickedDate) {
                            $hoursZone.html('');

                            var pickedPlain = pickedDate.getFullYear() + "-" + (pickedDate.getMonth() + 1) + "-" + pickedDate.getDate();
                            //console.log("pickedPlain:", pickedPlain)
                            $.each(utcDateTimes, function (index, value) {
                                var rowDate = moment(value.utc).tz(selectedTimeZone);
                                var rowPlain = rowDate.year() + "-" + (rowDate.month() + 1) + "-" + rowDate.date();
                                //console.log('rowPlain: ', rowPlain, ' --- ', 'pickedPlain: ', pickedPlain);
                                if (moment(rowPlain).isSame(pickedPlain, 'day')) {
                                    var interviewerid = value.interviewers[0];
                                    var hour = pad(rowDate.get('hour')) + ':00';
                                    var hourUS = formatAMPM(rowDate.get('hour'));
                                    //console.log(hour);
                                    $hoursZone.append('<button type="button" data-interviewer-id="' + interviewerid + '" data-utc="' + value.utc + '" class="hour-button">' + hourUS + '</button>');
                                }
                            });
                            $hourSelectZone.show();
                            $pickedTime.html(moment(pickedDate).format('LL') + ' <span></span>');
                        }
                    }
                };


                /** the buttons of the hours  */
                $(document).on('click', $('.hour-button'), function (e) {
                    if (hasClass(e.target, 'hour-button')) {
                        $('.hour-button').removeClass('selected');
                        var btn = $(e.target);
                        var interviewerId = btn.data('interviewer-id');
                        $('#form-interviewerid').val(interviewerId);
                        $('#form-utcval').val(btn.data('utc'));
                        $('#form-timezone').val($tz.val());
                        btn.addClass('selected');
                        $pickedTime.find('span').first().html(btn.html());

                        $interviewSubmit.removeAttr('disabled');
                        $selectedInterviewer.find('.img').html('<img src="' + dateMatrix[interviewerId].imgsrc + '">');
                        $selectedInterviewer.find('strong').html(dateMatrix[interviewerId].name);
                        $selectedInterviewer.find('span').html(dateMatrix[interviewerId].title);
                        $selectedInterviewer.show();
                        //console.log(btn.data('interviewer-id'));
                        //console.log(btn.data('utc'));
                    }
                });


                $('.interview-submit').click(function () {
                    $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to schedule <strong>' + $pickedTime.html() + '</strong> for the interview?');
                    $("#simple-confirm-modal").modal('show');
                    modalConfirm(function (confirm) {
                        if (confirm) {
                            $('.interview-submit')
                                .addClass('loading')
                                .attr('disabled', 'disabled')
                                .closest('form').submit();
                        }
                    })
                    $('#simple-confirm-modal').on('hidden.bs.modal', function (e) {});
                })


                /** Date Picker initialize */
                $dp.datepicker({
                    format: 'dd / MM / yyyy',
                    //startDate: '01-01-1900',
                    //endDate: $(this).data('end-date') || '+1y',
                    todayHighlight: false,
                    todayBtn: false,
                    toggleActive: false,
                    updateViewDate: true,
                    weekStart: 1,
                    maxViewMode: 0
                }).on('changeDate', datePicked);

                /** On TimeZone Change */
                $tz.on('change', timeZoneChanged).trigger('change');

                /** Disable Dates */
                //$dp.datepicker('setDatesDisabled', disableDates);

                datePicked();

                var $formInterviewerid = $('#form-interviewerid');
                if ($formInterviewerid.val() > 0) {
                    /**
                     var interviewerId = $formInterviewerid.val();
                     var ndt = new Date($interviewdate.val());
                     $dp.datepicker('setDate', ndt.toLocaleDateString());
                     */
                }

                $('a.interview-modify').click(function (e) {
                    e.preventDefault();
                    $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to change the appointment time?');
                    $("#simple-confirm-modal").modal('show');
                    modalConfirm(function (confirm) {
                        if (confirm) {
                            window.location = $('a.interview-modify').addClass('loading').attr("href");
                        }
                    })
                })
                $('a.interview-cancel').click(function (e) {
                    e.preventDefault();
                    $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to cancel your appointment ?');
                    $("#simple-confirm-modal").modal('show');
                    modalConfirm(function (confirm) {
                        if (confirm) {
                            window.location = $('a.interview-cancel').addClass('loading').attr("href");
                        }
                    })
                })
            }
        }

        /** Work Experience */
        if ($('.work-experience-records').length === 1) {
            $('[data-name="present"]').change(function () {
                var $presentCheckBox = $(this);
                var $workExperienceRecord = $presentCheckBox.closest('.work-experience-record'),
                    $enddate = $workExperienceRecord.find('[data-name="enddate"]');
                if ($presentCheckBox.is(':checked')) {
                    $enddate.attr('disabled', 'disabled').val('');
                } else {
                    $enddate.removeAttr('disabled');
                }
            })
        }

        /** Training/Internship Program */
        var $selectDuration = $('select#duration');
        if ($selectDuration.length === 1) {
            var $exchangeProgramType = $('[name="exchange_program_type"]'),
                selectDurationUpdate = function () {
                    var curVal = $selectDuration.val(),
                        maxMonth = 18;
                    $selectDuration.val(null).empty();
                    if ($exchangeProgramType.is(':checked')) {
                        if ($('[name="exchange_program_type"]:checked').val() === 'internship') {
                            if (curVal > 12) {
                                curVal = 12;
                            }
                            maxMonth = 12;
                        }
                    }
                    var newOption;
                    for (var i = 1; i <= maxMonth; i++) {
                        newOption = new Option(i + ' Month' + (i === 1 ? '' : 's'), i.toString(), false, false);
                        $selectDuration.append(newOption);
                    }
                    $selectDuration.val(curVal).trigger('change');
                }
            $exchangeProgramType
                .change(selectDurationUpdate)
                .trigger('change');

            var $securedOrganization = $('[name="secured_organization"]');
            $securedOrganization.change(function () {
                if ($securedOrganization.is(':checked')) {
                    if ($('[name="secured_organization"]:checked').val().toString() === '1') {
                        $('.company-fields').removeClass('hide');
                    } else {
                        $('.company-fields').addClass('hide');
                    }
                } else {
                    $('.company-fields').removeClass('hide');
                }
            })
        }

        /** J-2 Dependents */
        var $dependents_accompanyRadio = $('input[name="dependents_accompany"]');
        if ($dependents_accompanyRadio.length) {
            $dependents_accompanyRadio.change(function () {
                var $el = $('[name="dependents_accompany"]:checked');
                if ($el.length > 0 && $el.val().toString() === '1') {
                    $('.dependent-form').removeClass('d-none');
                } else {
                    $('.dependent-form').addClass('d-none');
                }
            }).trigger('change');
        }

        /** J-1 Evulation */
        var $supervisorchanged_accompanyRadio = $('form.after-mid-term-evaluation input[name="supervisorchanged"]');
        if ($supervisorchanged_accompanyRadio.length) {
            $supervisorchanged_accompanyRadio.change(function () {
                var $el = $('[name="supervisorchanged"]:checked');
                if ($el.length > 0 && $el.val().toString() === '1') {
                    $('.supervisor-block').removeClass('d-none');
                } else {
                    $('.supervisor-block').addClass('d-none');
                }
            }).trigger('change');
        }

        /** Submit Page */
        $('button.submit-application', $('form.initial-submit')).click(function () {
            $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to submit your application?');
            $("#simple-confirm-modal").modal('show');
            modalConfirm(function (confirm) {
                if (confirm) {
                    $('form.initial-submit').submit();
                }
            });
        });

        /** Health Insurance */
        var $spouse_or_childRadio = $('input[name="spouse_or_child"]');
        if ($spouse_or_childRadio.length) {
            $spouse_or_childRadio.change(function () {
                var $el = $('[name="spouse_or_child"]:checked');
                if ($el.length > 0 && $el.val().toString() === '1') {
                    $('.spouse_or_child-warn').removeClass('d-none');
                } else {
                    $('.spouse_or_child-warn').addClass('d-none');
                }
            }).trigger('change');
        }

        /** After - Check-in */
        if ($('.after-check-in-form').length === 1) {
            $('[data-target]', $('form.after-check-in-form')).click(function () {
                var name = $(this).data('target');
                if ($(this).is(':checked')) {
                    if ($(this).val() === '0') {
                        $('.' + name).addClass('d-none');
                    } else {
                        $('.' + name).removeClass('d-none').find('input').first().focus();
                    }
                } else {
                    $('.' + name).addClass('d-none');
                }
            });
        }

        /** Applicant Payment Page */
        if ($('form.j1-payment').length === 1) {
            $('.cancel-forward').click(function () {
                $('#express_service').prop('checked', false);
                $('.pay-now-cont').removeClass('d-none');
                $('.forward-payment-cont').addClass('d-none');
            });
            $('#express_service')
                .change(function (e) {
                    var $checkBox = varG1 = $(this);
                    if ($checkBox.prop('checked')) {
                        $('.pay-now-cont').addClass('d-none');
                        $('.forward-payment-cont').removeClass('d-none');
                    } else {
                        $('.pay-now-cont').removeClass('d-none');
                        $('.forward-payment-cont').addClass('d-none');
                    }
                    e.preventDefault();
                });
            $('.forward-payment').click(function () {
                $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to forward payment to host company?');
                $("#simple-confirm-modal").modal('show');
                modalConfirm(function (confirm) {
                    if (confirm) {
                        $('#express_service').addClass('posted').attr('disabled', 'disabled');
                        $('.cancel-forward').hide();
                        $('.forward-payment')
                            .addClass('loading disabled')
                            .attr('disabled', 'disabled')
                            .closest('form').submit();
                    }
                })
                $('#simple-confirm-modal').on('hidden.bs.modal', function (e) {
                    var $checkBox = $('#express_service');
                    if (!$checkBox.hasClass('posted')) {
                        $('#express_service').prop('checked', false);
                        $('.pay-now-cont').removeClass('d-none');
                        $('.forward-payment-cont').addClass('d-none');
                    }
                });
            });
        }

        /** Host Payment Page */
        if ($('.host-payment').length === 1) {
            var htmlBind = function () {
                    $('.forward-payment-to-applicant').click(function () {
                        $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to forward payment to J-1 Applicant?');
                        $("#simple-confirm-modal").modal('show');
                        modalConfirm(function (confirm) {
                            if (confirm) {
                                var btn = $('.forward-payment-to-applicant');
                                var id = btn.data('id');
                                $('.pay-now')
                                    .addClass('disabled')
                                    .attr('disabled', 'disabled');
                                btn
                                    .addClass('disabled posted')
                                    .attr('disabled', 'disabled');
                                $.ajax({
                                    type: "POST",
                                    url: btn.data('link'),
                                    data: {id: id},
                                    success: function (data) {
                                        if (data.success) {
                                            location.reload();
                                        }
                                    },
                                    error: function ($xhr, data) {
                                        $('.pay-now').removeClass('disabled').removeAttr('disabled');
                                        $('.forward-payment-to-applicant').removeClass('disabled').removeAttr('disabled');
                                        alert($xhr.responseJSON.error);
                                    }
                                });
                            }
                        })
                        $('#simple-confirm-modal').on('hidden.bs.modal', function (e) {
                            var btn = $('.forward-payment-to-applicant');
                            if (!btn.hasClass('posted')) {
                                $('.pay-now').removeClass('disabled').removeAttr('disabled');
                                btn.removeClass('disabled').removeAttr('disabled');
                            }
                        });
                    });

                    /** Pay now */
                    var btn = $('[data-payment-link]');
                    btn.click(function () {
                        btn.addClass('loading disabled').attr('disabled', 'disabled');
                        $('.forward-payment-to-applicant')
                            .addClass('disabled posted')
                            .attr('disabled', 'disabled');

                        var id = btn.data('payment-id'),
                            link = btn.data('payment-link');
                        var stripe = Stripe($('meta[name="stripe"]').attr('content'));
                        fetch(link, {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            body: JSON.stringify({
                                'applicant_id': id
                            })
                        })
                            .then(function (response) {
                                return response.json();
                            })
                            .then(function (session) {
                                return stripe.redirectToCheckout({sessionId: session.id});
                            })
                            .then(function (result) {
                                if (result.error) {
                                    alert(result.error.message);
                                }
                            })
                            .catch(function (error) {
                                console.error("Error:", error);
                            });
                    });
                },
                changeHtml = function (id, html) {
                    $('[data-target="' + id + '"]').html(html);
                },
                openPayment = function (id) {
                    $('.payment-group').removeClass('payment-group-opened');
                    $('.payment-group-' + id).addClass('payment-group-opened');
                    $('.payment-detail-cont').each(function () {
                        $(this)
                            .addClass('d-none')
                            .find("[data-target]")
                            .first()
                            .html("");
                    });
                    $('.applicant-name').removeClass('active');
                    var $group = $('#payment-' + id);
                    changeHtml(id, '<div class="text-center"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></div>');
                    $group.removeClass('d-none');
                },
                closePayment = function (id) {
                    $('.payment-group').removeClass('payment-group-opened');
                    $('#payment-' + id).addClass('d-none');
                    $('[data-id="' + id + '"]').removeClass('active');
                    changeHtml(id, '');
                };
            $('a.applicant-name').click(function (e) {
                var id = $(this).data('id'),
                    action = $(this).data('link'),
                    is_open = $(this).hasClass('active');
                if (is_open) {
                    closePayment(id);
                } else {
                    openPayment(id);
                    $(this).addClass('active');
                    $.ajax({
                        type: "POST",
                        url: action,
                        data: {id: id},
                        success: function (data) {
                            if (data.success) {
                                setTimeout(function () {
                                    changeHtml(id, data.tablehtml);
                                    htmlBind();
                                }, 500)
                            }
                        },
                        error: function ($xhr, data) {
                            //console.log($xhr.responseJSON.error);
                            changeHtml(id, "<div class=\"alert alert-danger\" role=\"alert\">\n" +
                                $xhr.responseJSON.error +
                                "</div>");
                            setTimeout(function () {
                                closePayment(id);
                            }, 2000)
                        }
                    });
                    window.location = $(this).data("href");
                }
                e.preventDefault();
                return false;
            });
            var hash = window.location.hash;
            if ($(hash).length === 1) {
                $('a[data-hash="' + hash.split('#')[1] + '"]').trigger('click');
            }
            $('.payment-side a').click(function (e) {
                $('a[data-hash="' + $(this).attr('href').split('#')[1] + '"]').trigger('click');
            })
        }
        $('.pay-now').click(function () {
            $(this).addClass('loading disabled').attr('disabled', 'disabled');
        })
    },
    refreshFormPageWithOutSubmit: function ($el) {
        var form = $el.closest('form');
        $('a,button').attr('disabled');
        $('button').addClass('disabled');
        form.find('.btn-wait').first().addClass('loading disabled');
        if (form.hasClass('only-refresh')) {
            location.reload();
        } else {
            form.submit();
        }
    },
    initialize: function () {

        /** Select 2*/
        $('.select2').select2({
            placeholder: function () {
                return $(this).hasData('placeholder') ? $(this).data('placeholder') : '';
            }
        });

        /** Bootstrap Datepicker */
        $('.datepicker').datepicker({
            format: 'dd / MM / yyyy',
            startDate: '01-01-1900',
            //endDate: $(this).data('end-date') || '+1y',
            maxViewMode: 2,
            todayHighlight: true,
            todayBtn: false,
            toggleActive: false,
            weekStart: 1,
        });

        /** Select all links with hashes */
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
            if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({scrollTop: target.offset().top - 90}, 200, function () {
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) {
                            return false;
                        } else {
                            $target.attr('tabindex', '-1');
                            $target.focus();
                        }
                    });
                }
            }
        });

        /** Hash Scroll */
        if (window.location.hash) {
            var hash = window.location.hash;
            if ($(hash).length) {
                $('html, body').animate({
                    scrollTop: $(hash).offset().top - 90
                }, 200);
            }
        }

        /** disable-on-submit Buttons */
        $('.disable-on-submit').each(function () {
            var $form = $(this).closest('form');
            $form.submit(function () {
                $form.find('button.disable-on-submit').attr('disabled', 'disabled').addClass('disabled loading');
            });
        });

        /** Input side select menu */
        $('input.type-select').each(function () {
            $(this).parent().find('a').click(function (e) {
                var id = $(this).data('id'),
                    title = $(this).text(),
                    $group = $(this).closest('.input-group-append'),
                    $button = $group.find('button'),
                    $input = $group.find('input');
                $group.find('a').removeClass('active');
                $(this).addClass('active');
                $input.val(id);
                $button.text(title);
                //$group.prev().focus();
                e.preventDefault();
            });
            $(this).parent().find('a.active').trigger('click');
        });

        /** Html Tooltip */
        $(".popover-html").popover({
            html: true,
            content: function () {
                return $($(this).data('url')).html();
            }
        }).on('hidden.bs.popover', function () {
            if ($($(this).data('url')).hasClass('popover-content-show-once')) {
                $(this).popover('disable');
            }
        })
        $(".popover-html.popover-show").popover('show');
        $(document).on("click", ".popover .close-me", function (e) {
            $(this).parents(".popover").popover('hide');
            e.preventDefault();
        });

        $('.send-click[data-target]').click(function (e) {
            $('#' + $(this).data('target')).trigger('click');
            e.preventDefault();
        })

        /** Mobile Menu */
        var happ = $('header.app'),
            body = $('body'),
            mm = $('.mobile-menu'),
            um = $('.user-menu')
        ;
        mm.click(function () {
            if (happ.hasClass('show-mobile-menu') || happ.hasClass('show-profile-menu')) {
                happ.removeClass('show-mobile-menu show-profile-menu');
                body.removeClass('ofh');
            } else {
                $(".app-content > .side").removeClass('open');
                happ.removeClass('show-profile-menu');
                happ.addClass('show-mobile-menu');
                body.addClass('ofh');
            }
        });
        um.find('.nav-item-chip').find('.nav-link').first().click(function () {
            if (happ.hasClass('show-profile-menu')) {
                mm.find('.dropdown-menu').removeClass('show');
                happ.removeClass('show-profile-menu show-mobile-menu');
                body.removeClass('ofh');
            } else {
                $(".app-content > .side").removeClass('open');
                happ.removeClass('show-mobile-menu');
                happ.addClass('show-profile-menu');
                body.addClass('ofh');
            }
        });
        $('.mobile-upload-photo').click(function (e) {
            $("#profile-image").trigger('click');
        });
        $('.open-side-menu').click(function (e) {
            $(".app-content > .side").addClass('open');
            body.addClass('ofh');
        });
        $('.close-side-menu').click(function (e) {
            $(".app-content > .side").removeClass('open');
            body.removeClass('ofh');
        });

    },
    copyRow: function () {
        var $cpBtn = $('a.add-multi-record');
        if ($cpBtn.length === 1) {
            $cpBtn.click(function (e) {
                var $multiRecords = $('div.multi-records'),
                    $row = $multiRecords.find('.first-record');

                $row.find('select.select2').each(function () {
                    $(this).select2('destroy');
                });
                $row.find('.datepicker').each(function () {
                    $(this).datepicker('remove');
                });

                var $newRow = $row.clone(true, true).removeClass('first-record');
                //, rowId = $newRow.data('row');
                var index = $multiRecords.find('.multi-record').length + 1;
                $newRow.attr('data-row', 'new-' + index);
                $newRow.find('input[name="rows[]"]').val('new-' + index);
                if ($newRow.find('.record-title').length > 0) {
                    $newRow
                        .find('.record-title')
                        .find('span')
                        .first()
                        .text(index);
                }

                $newRow.find('.form-group').each(function () {
                    var $formGroup = $(this),
                        $label = $formGroup.find('label[for]').first();
                    var $el = $formGroup.find('[data-name]');
                    $formGroup.find('.invalid-feedback').remove();
                    $el.first()
                        .attr('name', $el.data('name') + '[' + 'new-' + index + ']')
                        .attr('id', $el.data('name') + 'new-' + index)
                        .val('')
                        .removeClass('is-invalid');
                    $label.attr('for', $el.data('name') + 'new-' + index);

                    /** copy fu */
                    if ($formGroup.hasClass('fu')) {
                        var queueFiles = $formGroup.find('.queue-files').first();
                        $formGroup.attr('data-id', 'new-' + index);
                        $formGroup.removeClass('initalized preview traditional added-files');
                        $formGroup.find('.loaded-files').html("");
                        queueFiles.html('');
                    }
                });
                $newRow.find('.datepicker').each(function () {
                    $(this).datepicker('remove');
                });
                $newRow.appendTo($multiRecords);

                $('.select2', $multiRecords).select2({
                    placeholder: function () {
                        return $(this).hasData('placeholder') ? $(this).data('placeholder') : '';
                    }
                });
                $('.datepicker', $multiRecords).datepicker({
                    format: 'dd / MM / yyyy',
                    startDate: '01-01-1900',
                    endDate: '+1y',
                    maxViewMode: 2,
                    todayHighlight: true,
                    todayBtn: false,
                    toggleActive: false,
                    weekStart: 1,
                });
                app.updateHtmlForUpload();
                e.preventDefault();
            })

            /** Remove Row */
            $('a.remove-multi-record').click(function (e) {
                $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to permanently remove this record?');
                $("#simple-confirm-modal").modal('show');
                varG1 = $(this).parent();
                modalConfirm(function (confirm) {
                    if (confirm) {
                        varG1.hide(300, function () {
                            varG1.remove();
                            varG1 = null;
                        });
                    } else {
                        varG1 = null;
                        // do nothing
                    }
                });
                e.preventDefault();
            });
        }
    },
    phoneMask: function () {
        /** Phone Mask */
        // https://github.com/RobinHerbots/Inputmask
        if ($('[data-mask-field]').length > 0) {
            phoneCodes = (function () {
                var json = null;
                $.ajax({
                    'async': false, 'global': false,
                    'url': '/assets/js/phone-codes.json',
                    'dataType': "json",
                    'success': function (data) {json = data;}
                });
                return json;
            })();
            var applyPhoneMask = function (code, $el) {
                //console.log(phoneCodes);
                var masks = [];
                for (var i in phoneCodes) {
                    if (phoneCodes.hasOwnProperty(i)) {
                        if (Object.prototype.toString.call(phoneCodes[i].cc) === '[object Array]') {
                            for (var j in phoneCodes[i].cc) {
                                if (phoneCodes[i].cc.hasOwnProperty(j) && phoneCodes[i].cc[j] === code) {
                                    masks.push(phoneCodes[i].mask.replace('+', ''))
                                    //console.log(phoneCodes[i].cc[j]);
                                }
                            }
                        }
                        if (typeof phoneCodes[i].cc === 'string' && phoneCodes[i].cc === code) {
                            masks.push(phoneCodes[i].mask.replace('+', ''))
                            //console.log(phoneCodes[i].mask);
                        }
                    }
                }

                $el.attr('placeholder', '');
                if (masks.length > 0) {
                    var mask = masks[0].replace('(', ' (').replace(')', ') '),
                        placeholderString = '+' + $.trim(mask.replace(/\#/gi, '0')),
                        escapeString = $.trim(mask.replace(/[-\#][\(\#\)]+/gi, '')),
                        maskString = $.trim(mask.replaceAll(/\#/g, '9'));
                    maskString = '+\\' + escapeString + maskString.replace(escapeString, '');

                    /*
                    // AE æ xxx
                    console.log('mask:', mask);
                    console.log('placeholderString:', '-' + placeholderString + '-');
                    console.log('maskString:', '-' + maskString + '-');
                    console.log('escapeString:', '-' + escapeString + '-');
                    console.log(maskString);
                     */
                    $el.attr('placeholder', placeholderString)
                        .inputmask({
                            "mask": maskString,
                            clearMaskOnLostFocus: false,
                            placeholder: "_",
                        });
                    //console.log(masks);
                }
            }


            /*            $('[data-mask-field]').change(function () {
                            var code = $(this).val(),
                                $el = $('#' + $(this).data('mask-field'));
                            applyPhoneMask(code, $el);
                        }).trigger('change');*/

        }
        $('input[data-mask]').each(function (e) {
            var mask = $(this).data('mask');
            $(this).inputmask({
                "mask": mask,
                clearMaskOnLostFocus: false,
                placeholder: "_",
            });


        });
    },
    phoneFlag: function () {
        //var phn = $('[data-mask-field]');
        var phn = $('.phone-mask');
        if (phn.length > 0) {
            phn.intlTelInput({
                nationalMode: false,
                autoPlaceholder: "aggressive",
                preferredCountries: [],
            });
        }
    },
    profileImage: function () {
        var $ppChange = $('#pp-change');
        var $selectButton = $ppChange.find('.upload-photo');
        var $deletePhoto = $ppChange.find('.delete-photo');
        var Upload = function (file) {this.file = file;};
        Upload.prototype.getType = function () {return this.file.type;};
        Upload.prototype.getSize = function () {return this.file.size;};
        Upload.prototype.getName = function () {return this.file.name;};
        Upload.prototype.doUpload = function () {
            var that = this;
            var formData = new FormData();
            formData.append("profilePicture", this.file, this.getName());
            formData.append("upload_profile_image", 'true');
            formData.append("settype", 'personal');
            $.ajax({
                type: "POST",
                url: "/app/profile-image",
                xhr: function () {
                    var jqXHR = $.ajaxSettings.xhr();
                    if (jqXHR.upload) {
                        jqXHR.upload.addEventListener('progress', that.progressHandling, false);
                    }
                    return jqXHR;
                },
                success: function (data) {
                    if (parseInt(data.err) === 0) {
                        $ppChange.find('.img').html('<img src="' + data.src + '" class="img-fluid" alt="">');
                        $('header.app .chip .media').removeClass('empty');
                        var headerPP = $('header.app .nav-link .chip img')
                        if (headerPP.length) {
                            headerPP.attr('src', data.src).show();
                            $('.profile-card .media img').attr('src', data.src).show();
                        } else {
                            $('header.app .nav-link .chip .media').html('<img src="' + data.src + '" class="figure-img avatar" alt="" >');
                            $('.profile-card .media').html('<img src="' + data.src + '" class="figure-img avatar" alt="" >');
                        }
                    }
                    $selectButton.removeClass('loading disabled').removeAttr('disabled');
                    $deletePhoto.removeClass('d-none');
                    $ppChange.removeClass('uploading');
                    $('.user-menu').removeClass('animate');
                    $ppChange.find('.percent').text("0%");
                },
                error: function (error) {
                    // handle error
                    //console.log(error);
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 300000
            });
        };
        Upload.prototype.progressHandling = function (event) {
            var percent = 0,
                position = event.loaded || event.position,
                total = event.total;
            if (event.lengthComputable) {
                percent = Math.ceil(position / total * 100);
            }
            $ppChange.find('.percent').text(percent + "%");
        };

        /** Profil Resmi */
        $("#profile-image").on("change", function () {
            if ($(this)[0].files[0]) {
                var file = $(this)[0].files[0];
                $ppChange.addClass('uploading');
                $deletePhoto.addClass('d-none');
                $selectButton.addClass('loading disabled').attr('disabled', 'disabled');
                $('.user-menu').addClass('animate');
                var upload = new Upload(file);
                upload.doUpload();
            }
        });
        $selectButton.click(function () {
            if ($(this).hasClass('disabled')) {
                return false;
            }
            $("#profile-image").trigger('click');
        });
        $deletePhoto.click(function () {
            $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to permanently remove your profile image?');
            $("#simple-confirm-modal").modal('show');
            modalConfirm(function (confirm) {
                if (confirm) {
                    $selectButton.hide();
                    $deletePhoto.addClass('disabled').attr('disabled', 'disabled');
                    $.ajax({
                        type: "POST",
                        url: "/app/remove-profile-image",
                        data: {},
                        success: function (/*data*/) {
                            $ppChange.find('.img').html('<div class="empty"></div>');
                            $('header.app .nav-link .chip .media').addClass('empty').find("img").attr('src', '').hide();
                            $deletePhoto.removeClass('disabled').removeAttr('disabled').addClass('d-none');
                            $selectButton.show();
                        },
                        error: function (/*error*/) {
                            $deletePhoto.removeClass('disabled').removeAttr('disabled');
                            $selectButton.show();
                        }
                    });
                }
            });
        });
    },


    mandatoryDocumentsPage: function () {
        var $mdp = $('.mandatory-documents-page');
        if ($mdp.length === 1 && !$mdp.hasClass('mandatory-documents-page-completed')) {
            var checkPage = function () {
                var allFilesDownloaded = $('.downloadable-file').length === $('.downloadable-file.downloaded').length,
                    submitButton = $('button[type="submit"]'),
                    checkbox = $('input.custom-control-input'),
                    checked = checkbox.prop('checked');

                if (allFilesDownloaded) {
                    checkbox.removeAttr('disabled');
                }
                if (checked) {
                    submitButton.removeAttr('disabled').removeClass('disabled');
                } else {
                    submitButton.attr('disabled', 'disabled').addClass('disabled');
                }
                //submitButton.removeAttr('disabled').removeClass('disabled');
            };
            $('input.custom-control-input').on('click', function () {
                checkPage();
            });
            $('.downloadable-file').on('click', function () {
                checkPage();
            });
            checkPage();

        }
    },
    ParticipantHandbookPage: function () {
        var $mdp = $('.participant-handbook-page');
        if ($mdp.length === 1 && !$mdp.hasClass('participant-handbook-page-completed')) {
            var checkPage = function () {
                var allFilesDownloaded = $('.downloadable-file').length === $('.downloadable-file.downloaded').length,
                    submitButton = $('button[type="submit"]'),
                    checkbox = $('input.custom-control-input'),
                    checked = checkbox.prop('checked');

                if (allFilesDownloaded) {
                    checkbox.removeAttr('disabled');
                }
                if (checked) {
                    submitButton.removeAttr('disabled').removeClass('disabled');
                } else {
                    submitButton.attr('disabled', 'disabled').addClass('disabled');
                }
                //submitButton.removeAttr('disabled').removeClass('disabled');
            };
            $('input.custom-control-input').on('click', function () {
                checkPage();
            });
            $('.downloadable-file').on('click', function () {
                checkPage();
            });
            checkPage();

        }
    },
    hostApplication: function () {
        var $mdp = $('.host-app-form-main');
        if ($mdp.length === 1) {
            var checkbox = $('input[name="site_address_confirm"]');
            var site_addres = $('#site_addres');
            var checkFn = function () {
                if ($('#site_address_confirm:checked').val() == 1) {
                    site_addres.removeClass('hide');
                } else {
                    site_addres.addClass('hide');
                }
            };
            checkFn();
            checkbox.on('click change', checkFn);


            $('a.add-multi-record-top-right').click(function () {
                $('.modal-header .modal-title').html('Add New J-1 Exchange Visitor');
                $('.modal-body', "#simple-confirm-modal").html('Are you planning to host a new J-1 exchange visitor?');
                $("#simple-confirm-modal").modal('show');
                modalConfirm(function (confirm) {
                    if (confirm) {
                        $('a.add-multi-record-top-right')
                            .addClass('loading')
                            .attr('disabled', 'disabled');

                        window.location = $('form.site-form').attr('action') + '?reopen=on';
                    }
                })
                $('#simple-confirm-modal').on('hidden.bs.modal', function (e) {});
            })


        }
    },

    financialSecurityStatement: function () {
        var $fss = $('.financial-security-statement');
        if ($fss.length === 1) {
            $('#file-cont-file_finance').detach().appendTo($(".FinancialSecurityStatement-Container-amounthost"));
            $('#file-cont-file_finance2').detach().appendTo($(".FinancialSecurityStatement-Container-amountparents"));
            $('#file-cont-file_finance3').detach().appendTo($(".FinancialSecurityStatement-Container-amountmyself"));
            $('.FinancialSecurityStatement-File').remove();

            var $is_formDisabled = $fss.closest('form').hasClass('.disable-form');
            $(".maskMoney").maskMoney();
            var radios = $('[name="incometype"]');
            var checkPage = function () {
                if ($('[name="incometype"]:checked').length === 0) {
                    return false;
                }
                radios.each(function () {
                    var radio = $(this),
                        inputFor = radio.data('inputfor');
                    if (radio.prop('checked')) {
                        if (!$is_formDisabled) {
                            $('[name="' + inputFor + '"]').removeAttr('disabled').focus();
                        }
                        $('.desc-' + inputFor).removeClass('d-none');
                    } else {
                        $('[name="' + inputFor + '"]').attr('disabled', 'disabled').val('');
                        $('.desc-' + inputFor).addClass('d-none');
                    }
                })
            };
            radios.on('change', function () {
                checkPage();
            });
            checkPage();
        }
    },
    USembassyConsulateInterview: function () {
        if ($('.us-embassy-or-consulate-interview').length === 1) {
            var radios = $('input.dg-radio-decision');
            var checkPage = function () {
                if ($('input.dg-radio-decision:checked').length > 0) {
                    radios.each(function () {
                        var radio = $(this),
                            inputFor = radio.data('inputfor');
                        if (radio.prop('checked')) {
                            $('.cont-' + inputFor).removeClass('d-none');
                        } else {
                            $('.cont-' + inputFor).addClass('d-none');
                        }
                    })
                }
            };
            radios.on('change', function () { checkPage(); });
            checkPage();

            var radiosTravel = $('input.dg-radio-travelplan');
            var checkPageTravel = function () {
                if ($('input.dg-radio-travelplan:checked').length > 0) {
                    radiosTravel.each(function () {
                        var radio = $(this),
                            inputFor = radio.data('inputfor');
                        if (radio.prop('checked')) {
                            $('.cont-' + inputFor).removeClass('d-none');
                        } else {
                            $('.cont-' + inputFor).addClass('d-none');
                        }
                    })
                }
            };
            radiosTravel.on('change', function () { checkPageTravel(); });
            checkPageTravel();

            /** Dependency */
            var radiosDependency = $('input.dg-radio-dependency_record_decision');
            var checkPageDependency = function () {
                if ($('input.dg-radio-dependency_record_decision:checked').length > 0) {
                    radiosDependency.each(function () {
                        var radio = $(this),
                            inputFor = radio.data('inputfor');
                        if (radio.prop('checked')) {
                            $('.cont-' + inputFor).removeClass('d-none');
                        } else {
                            $('.cont-' + inputFor).addClass('d-none');
                        }
                    })
                }
            };
            radiosDependency.on('change', function () {
                checkPageDependency();
            });
            checkPageDependency();

        }
    },
    hostCompensationDetails: function () {
        var $hcd = $('.host-compensation-details');
        if ($hcd.length === 1) {
            $(".maskMoney").maskMoney();
            var compensation_radio = $('input.compensation-radio'),
                compensationvalue_cont = $('.compensationvalue-cont'),
                checkPage = function () {
                    if (parseInt($('input.compensation-radio:checked').val()) === 1) {
                        compensationvalue_cont.removeClass('d-none');
                    } else {
                        compensationvalue_cont.addClass('d-none');
                    }

                };
            compensation_radio.on('change click', function () {
                checkPage();
            });
            checkPage();
        }
    },
    applicantselect: function () {
        var $applicantselect = $('#applicantselect');
        if ($applicantselect.length === 1) {
            $('#applicantselect').on('change', function () {
                var val = $(this).val();
                var path = window.location.href.split('?')[0];
                path += '?applicant=' + val;
                window.location = path;
            });
        }
    },
    advancedFileUpload: function (fileInput) {
        var $fu = fileInput.closest('div.fu'),
            $labelMain = $fu.find('.fu-label').first(),
            $form = $fu.closest('form'),
            multible = $fu.hasClass('multible') ? 'on' : '',
            projectUploading = $fu.find('.project__uploading').first(),
            $percent_bar = projectUploading.find('.progress em'),
            $percent_text = projectUploading.find('.text span'),
            $file_text = projectUploading.find('.file-text'),
            fieldName = $fu.data('key'),
            className = $fu.data('type'),
            dataId = $fu.data('id'),
            jqXHR = null
        ;
        /*
        console.log(fieldName);
        console.log(className);
        console.log(dataId);
        return false;
        */
        var startUpload = function () {
            projectUploading.removeClass('d-none');
            $percent_bar.css('width', '1%');
            $percent_text.text('%1');
            var Upload = function (file) {this.file = file;};
            Upload.prototype.getType = function () {return this.file.type;};
            Upload.prototype.getSize = function () {return this.file.size;};
            Upload.prototype.getName = function () {return this.file.name;};
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();
                formData.append(fieldName, this.file, this.getName());
                formData.append("fieldName", fieldName);
                formData.append("className", className);
                formData.append("multible", multible);
                formData.append("dataId", dataId);
                formData.append("ajaxUpload", 'on');
                $file_text.html(this.getName());
                $.ajax({
                    type: "POST",
                    url: '/app/file-upload',
                    xhr: function () {
                        jqXHR = $.ajaxSettings.xhr();
                        if (jqXHR.upload) {
                            jqXHR.upload.addEventListener('progress', that.progressHandling, false);
                        }
                        return jqXHR;
                    },
                    success: function (data) {
                        $percent_bar.stop().css({'width': 1 + "%"})
                        $percent_text.text('%' + 1);
                        curentFileIndex++;
                        if (curentFileIndex < totalFilesCount) {
                            upload = new Upload(fileInput[0].files[curentFileIndex]);
                            upload.doUpload();
                        } else {
                            // All done
                            $fu.removeClass('uploading');
                            $fu.addClass('reloading');
                            app.refreshFormPageWithOutSubmit($fu);
                        }
                    },
                    error: function (data) {
                        $fu.removeClass('uploading');
                        projectUploading.addClass('d-none');
                        $percent_bar.css({'width': 1 + "%"})
                        $percent_text.text('%1');
                        $labelMain.find('.label').first().addClass('is-invalid').after('<span class="invalid-feedback" role="alert"><strong>' + data.responseJSON.errmsg + '</strong></span>');
                    },
                    async: true, data: formData, cache: false, contentType: false, processData: false, timeout: 300000
                });
            };
            Upload.prototype.progressHandling = function (event) {
                var percent = 0, position = event.loaded || event.position, total = event.total;
                if (event.lengthComputable) {
                    percent = Math.ceil(position / total * 100);
                }
                $percent_bar.stop().animate({'width': percent + "%"})
                $percent_text.text('%' + percent);
            };

            /** Start Uploading */
            $labelMain.find('.label').first().removeClass('is-invalid');
            $labelMain.find('.invalid-feedback').remove();
            $fu.addClass('uploading');
            totalFilesCount = fileInput[0].files.length;
            curentFileIndex = 0;
            var upload = new Upload(fileInput[0].files[curentFileIndex]);
            upload.doUpload();
        };

        startUpload();
    },
    updateHtmlForUpload: function () {
        var uploadLabels = $('label.fu-custom');

        //isAdvancedUpload = false; //geçici

        /** Uploads */
        uploadLabels.each(function () {
            var uploadLabel = $(this),
                $fu = uploadLabel.closest('div.fu'),
                is_fu_initalized = $fu.hasClass('initalized'),
                is_multible = $fu.hasClass('multible'),
                is_fu_preview = $fu.hasClass('preview');
            if (!is_fu_initalized && (!is_fu_preview || is_multible)) {
                var fieldName = $fu.data('key'),
                    fileInput = $fu.find('[data-fieldname="' + fieldName + '"]'),
                    queueFiles = $fu.find('.queue-files').first(),
                    cancelQueue = $fu.find('.cancel-queue').first()
                ;
                /** Fu row initalized */
                $fu.addClass('initalized');

                /** Classic Uploading */
                if (!isAdvancedUpload) {
                    /** Traditional File */
                    cancelQueue.find('.cancel-button').click(function () {
                        queueFiles.html('');
                        fileInput.val('');
                        $fu.removeClass('traditional');
                        $fu.removeClass('added-files');
                    });
                }

                /** On add new file(s) */
                $(fileInput).change(function () {
                    queueFiles.html('');
                    $fu.removeClass('traditional');
                    $fu.removeClass('added-files');
                    var i, filename, filesLength = fileInput[0].files.length, isFileAdded = false;
                    for (i = 0; i < filesLength; i++) {
                        filename = fileInput[0].files[i].name
                        if (filename.length > 0) {
                            isFileAdded = true;
                            queueFiles.append('<div class="file-text">' + filename + '</div>');
                        }
                    }
                    if (isAdvancedUpload) {
                        app.advancedFileUpload(fileInput);
                    } else {
                        if (isFileAdded) {
                            $fu.addClass('traditional');
                            $fu.addClass('added-files');
                        }
                    }
                });
            }
        })
        /** Download Links */
        $('.downloadable-file').unbind().click(function () {
            $(this).addClass('downloaded').html('Downloaded');
            $('label[for="' + $(this).data('target') + '"]').addClass('label-downloaded').removeAttr('disabled');
        });
        $('label.fu-custom.downloadable').unbind().click(function (e) {
            if (!$(this).hasClass('label-downloaded')) {
                e.preventDefault();
            }
        });

        /** Remove File */
        $('.loaded-files .remove-file').unbind().click(function () {
            var btn = $(this);
            varG1 = btn.closest('.fu').data('type');
            varG2 = btn.parent().data('file_id');
            varG3 = btn.parent().data('fileable_id');
            varG4 = btn.closest('.fu').data('key');
            $('.modal-body', "#simple-confirm-modal").html('Are you sure you want to permanently remove this file?');
            $("#simple-confirm-modal").modal('show');
            modalConfirm(function (confirm) {
                if (confirm) {
                    $.ajax({
                        type: "POST",
                        url: "/app/remove-file",
                        data: {'type': varG1, 'file_id': varG2, 'fileable_id': varG3, 'fieldname': varG4},
                        success: function (/*data*/) {
                            app.refreshFormPageWithOutSubmit(btn);
                            btn.parent().remove();
                        },
                        error: function (/*error*/) {
                            app.refreshFormPageWithOutSubmit(btn);
                            btn.parent().remove();
                        }
                    });
                } else {
                    varG1 = null;
                    varG2 = null;
                    varG3 = null;
                    varG4 = null;
                }
            });
        });

        /** todo: Drag & Drop */
        if (isAdvancedUpload) {
            // preventing page from redirecting
            $("html")
                //.unbind()
                .on("dragover dragenter", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    //$('.fu').addClass('dragover');
                })
                .on("drop", function (e) {
                    //$('.fu').removeClass('dragover');
                    e.preventDefault();
                    e.stopPropagation();
                });
            $('.fu.dragable').each(function () {

                var fu = $(this);
                fu.on('drag dragstart dragend dragleave', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }).on('dragover dragenter', function () {
                    if (fu.hasClass('disabled')) {
                        fu.removeClass('is-dragover');
                    } else {
                        fu.addClass('is-dragover');
                    }
                }).on('dragleave dragend', function () {
                    fu.removeClass('is-dragover');
                }).on('drop', function (e) {
                    fu.removeClass('is-dragover');
                    if (!fu.hasClass('disabled')) {
                        var is_abletoupload = true,
                            droppedFiles = e.originalEvent.dataTransfer.files;
                        if (droppedFiles.length > 1 && !fu.hasClass('multible')) {
                            is_abletoupload = false;
                        }
                        if (is_abletoupload) {
                            var $input = fu.find('[type="file"]').first();
                            $input[0].files = droppedFiles;
                            $input.trigger('change');
                        }
                        //console.log(droppedFiles);
                        //console.log($input);
                        if (droppedFiles.length === 1) {
                            //console.log(droppedFiles);
                        } else {
                            //showError("Lütfen sadece bir dosya yükleyin");
                        }
                    }
                });
            })
        }

    },
    uploads: function () {
        if ($('.fu-copied').length > 0) {
            isAdvancedUpload = false;
        } else {
            isAdvancedUpload = function () {
                var div = document.createElement('div');
                //return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
                return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div));
            }();
        }

        var uploadLabels = $('label.fu-custom');
        if (uploadLabels.length > 0) {
            this.updateHtmlForUpload();
        }

        /** Only Download */
        $('.downloadable-file-only').unbind().click(function () {
            $(this).addClass('downloaded').html('Downloaded');
        });
    }
};

(function (/*$*/) {
    app.initialize();
    app.authForms();
    app.copyRow();
    app.phoneFlag();
    app.phoneMask();
    app.profileImage();
    app.uploads();
    app.mandatoryDocumentsPage();
    app.ParticipantHandbookPage();
    app.hostApplication();
    app.financialSecurityStatement();
    app.USembassyConsulateInterview();
    app.hostCompensationDetails();
    app.applicantselect();

    /** Disable Form */
    $('.disable-form').closest('form').find('input, textarea, button, select').attr('disabled', 'disabled');

})(jQuery);